import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';
import { Action, BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';

@Component({
  selector: 'yt-akcija-update',
  templateUrl: './akcija-update.component.html',
  styleUrls: ['./akcija-update.component.scss']
})
export class AkcijaUpdateComponent extends BaseUpdateComponent<Action> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    this.baseFormGroup.patchValue({DefaultValue: false});
    this.baseFormGroup.patchValue({SendToClient: true});
    this.addValidatorToFc("Name", Validators.required, 'required', 'ACTION.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Model", Validators.required, 'required', 'ACTION.MODEL.VALIDATION.REQUIRED');
  }

}
